const routeConstants = {
  login: "/login",
  dashboard: "/",
  myProfile: "/profile",
  campaigns: "/campaigns",
  manageDataSource: "/manage-data-source",
  reports: "/reports",
  generateReports: "/generate-reports",
  generatedReport: "/reports/generated-report",
  conversions: "/conversions",
  conversionDetails: "/conversion-details",
  adCopies: "/ad-copies",
  learnAboutTrialPartners: "/learn-about-trial-partners",
  sendFeedback: "/send-feedback",
  aboutUs: "/about-us",
  privacyPolicy: "/privacy-policy",
};

export default routeConstants;
